// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "age":'',
    "gender":'',
    "alert_title":'',
    'alert_message':'',
    "alert_severity":[],
    "user_id":'',
    "user_name":'',
    "created_day": '',
    "created_month": '',
    "created_year": '',
    "age_inverse": '',
    "gender_inverse": '',
    "alert_title_inverse":'',
    "alert_message_inverse":'',
    "alert_severity_inverse":'',
    "user_id_inverse":'',
    "user_name_inverse":'',
    "created_date_inverse": '',
    "match": false,
    "AlertNotificationSearchApplied": false,
};

const AlertNotificationSearchSlice = createSlice({
    name: 'AlertNotificationSearch',
    initialState,
    reducers: {
        setAlertNotificationSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetAlertNotificationSearch(state) {
            return { ...initialState, AlertNotificationSearchApplied: false }; // Reset state and flag
        },
        setAlertNotificationSearchApplied(state) {
            state.AlertNotificationSearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setAlertNotificationSearch, 
    resetAlertNotificationSearch, 
    setAlertNotificationSearchApplied } = AlertNotificationSearchSlice.actions;

export default AlertNotificationSearchSlice.reducer;